<template>
    <div class="process-time-line">
        <div
            class="process-card"
            v-for="(data, index) in list"
            :key="data.swapId"
            :id="`a${data.swapId}`"
        >
            <div class="process-card-top">
                <i class="el-icon-arrow-down"></i>
                <span class="text date"
                    >{{ data.opDate }} - {{ data.cardName }}</span
                >
                <span class="text">/</span>
                <span class="text">{{ data.opPerson }}</span>
                <img
                    v-if="data.config.cardKey === 'afterSales'"
                    class="content-icon top-icon-right"
                    :src="require(`@/modules/sn/assets/images/engineer.png`)"
                />
                <img
                    v-else
                    class="content-icon top-icon-right"
                    :src="require(`@/modules/sn/assets/images/scammen.png`)"
                />
            </div>
            <div class="processTimeLine-info">
                <div class="processTimeLine-info-title">
                    <span class="processTimeLine-info-name">{{
                        data.sourceBillNo
                    }}</span>
                    <span class="processTimeLine-info-label">{{
                        data.billTypeName
                    }}</span>
                    <span class="processTimeLine-info-type">{{
                        rowContentFactory(data.recSourceSys)
                    }}</span>
                </div>
                <div class="processTimeLine-info-content">
                    <div class="processTimeLine-info-left">
                        <div>
                            <img
                                src="../../../../../assets/images/circle.png"
                                class="processTimeLine-icon"
                                alt=""
                            />
                            <span class="processTimeLine-info-left-title">
                                {{ data.shipOrgType || '--' }}</span
                            >
                        </div>
                        <div
                            class="processTimeLine-row"
                            v-for="(item, i) in rowOption.infoLeft"
                            :key="i"
                        >
                            <span class="processTimeLine-row-label">{{
                                item.label
                            }}</span>
                            <span class="processTimeLine-row-val">
                                {{
                                    rowContentFactory(
                                        data[item.name],
                                        data[item.code]
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            class="processTimeLine-row flex-row"
                            v-if="needAddressEye(data)"
                            @click="
                                changeEyeInfo(
                                    'address',
                                    data.sourceBillNo,
                                    index
                                )
                            "
                        >
                            <img
                                :src="getEyeImgUrl(data.addressEyeShow)"
                                class="processTimeLine-eye"
                            />
                            <span
                                class="processTimeLine-row-label processTimeLine-row-labelIcon"
                            >
                                收件地址：
                            </span>
                            <span class="processTimeLine-row-val color4285F5">
                                {{
                                    data.addressEyeShow
                                        ? data.addressEyeInfo
                                        : '************'
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="processTimeLine-info-right">
                        <div>
                            <img
                                src="../../../../../assets/images/circle-r.png"
                                class="processTimeLine-icon"
                                alt=""
                            />
                            <span class="processTimeLine-info-left-title">
                                {{ data.recOrgType || '--' }}</span
                            >
                        </div>
                        <div
                            class="processTimeLine-row"
                            v-for="(item, i) in rowOption.infoRight"
                            :key="i"
                        >
                            <span class="processTimeLine-row-label">{{
                                item.label
                            }}</span>
                            <span class="processTimeLine-row-val">
                                {{
                                    rowContentFactory(
                                        data[item.name],
                                        data[item.code]
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            class="processTimeLine-row flex-row"
                            v-if="needPhoneEye(data)"
                        >
                            <img
                                :src="getEyeImgUrl(data.phoneEyeShow)"
                                class="processTimeLine-eye"
                                @click="
                                    changeEyeInfo(
                                        'phone',
                                        data.sourceBillNo,
                                        index
                                    )
                                "
                            />
                            <span
                                class="processTimeLine-row-label processTimeLine-row-labelIcon"
                            >
                                收件人：
                            </span>
                            <span class="processTimeLine-row-val color4285F5">
                                {{
                                    data.phoneEyeShow
                                        ? data.phoneEyeInfo
                                        : '************'
                                }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="processTimeLine-logistics">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item title="物流信息" :name="data.swapId">
                            <template slot="title">
                                <i
                                    class="el-icon-arrow-down"
                                    v-if="activeNames.includes(data.swapId)"
                                ></i>
                                <i class="el-icon-arrow-up" v-else></i>
                                <span> 物流信息 </span>
                            </template>
                            <div class="logistics-content">
                                <div class="logistics-content-heightLight">
                                    <span>任务单号：</span>
                                    <span>{{
                                        rowContentFactory(data.taskNo)
                                    }}</span>
                                    <span class="processTimeLine-info-label">{{
                                        data.scanSystem
                                    }}</span>
                                </div>
                                <div class="logistics-content-info">
                                    <div class="logistics-info-left">
                                        <div
                                            class="processTimeLine-row"
                                            v-for="(
                                                item, i
                                            ) in rowOption.logisticsLeft"
                                            :key="i"
                                        >
                                            <span
                                                class="processTimeLine-row-label"
                                                >{{ item.label }}</span
                                            >
                                            <span
                                                class="processTimeLine-row-val"
                                            >
                                                {{
                                                    rowContentFactory(
                                                        data[item.name],
                                                        data[item.code]
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="logistics-info-right">
                                        <div
                                            class="processTimeLine-row processTimeLine-rowTwo"
                                        >
                                            <div
                                                class="processTimeLine-rowTwo-item depart"
                                            >
                                                <span
                                                    class="processTimeLine-row-label"
                                                    >发车单号：</span
                                                >
                                                <span
                                                    class="processTimeLine-row-val"
                                                >
                                                    {{
                                                        rowContentFactory(
                                                            data.dispatchNo
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="processTimeLine-rowTwo-item"
                                            >
                                                <span
                                                    class="processTimeLine-row-label"
                                                    >司机：</span
                                                >
                                                <span
                                                    class="processTimeLine-row-val"
                                                >
                                                    {{
                                                        rowContentFactory(
                                                            data.driver
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            class="processTimeLine-row"
                                            v-for="(
                                                item, i
                                            ) in rowOption.logisticsRight"
                                            :key="i"
                                        >
                                            <span
                                                class="processTimeLine-row-label"
                                                >{{ item.label }}</span
                                            >
                                            <span
                                                class="processTimeLine-row-val"
                                            >
                                                {{
                                                    rowContentFactory(
                                                        data[item.name],
                                                        data[item.code]
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProcessTimeLine',
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeNames: [],
            rowOption: {
                infoLeft: [
                    {
                        label: '发货单位：',
                        name: 'shipOrgName',
                        code: 'shipOrgCode'
                    },
                    {
                        label: '营销中心：',
                        name: 'branchName',
                        code: 'branchCode'
                    },
                    {
                        label: '发货仓库：',
                        name: 'shipOrgWhName',
                        code: 'shipOrgWhCode'
                    }
                ],
                infoRight: [
                    {
                        label: '收货单位：',
                        name: 'recOrgName',
                        code: 'recOrgCode'
                    },
                    {
                        label: '直发客户：',
                        name: 'customerName',
                        code: 'customerCode'
                    },
                    {
                        label: '收货仓库：',
                        name: 'recOrgWhName',
                        code: 'recOrgWhCode'
                    }
                ],
                logisticsLeft: [
                    {
                        label: '扫码仓库：',
                        name: 'whName',
                        code: 'whCode'
                    },
                    {
                        label: '服务平台：',
                        name: 'siteName'
                    },
                    {
                        label: '网点：',
                        name: 'netWorkName'
                    },
                    {
                        label: '业务模式',
                        name: 'businessMode'
                    },
                    {
                        label: '配送方式：',
                        name: 'deliveryTypeName'
                    }
                ],
                logisticsRight: [
                    {
                        label: '承运商：',
                        name: 'carrierName',
                        code: 'carrierCode'
                    },
                    {
                        label: '外部平台单号：',
                        name: 'externalOrderNo'
                    },
                    {
                        label: '外部货主：',
                        name: 'upCustomerName'
                    },
                    {
                        label: '运单号：',
                        name: 'expressCode'
                    }
                ]
            }
        };
    },
    methods: {
        rowContentFactory(value, code) {
            let content = '--';
            if (value) {
                content = value + '';
                if (code) content = value + '(' + code + ')';
            }
            return content;
        },
        scrollIntoView(id) {
            // 通过ref名获取元素在页面中的位置并滚动至此
            this.$el
                .querySelector(`#a${id}`)
                .scrollIntoView({ block: 'start', behavior: 'smooth' });
        },
        getEyeImgUrl(isOpen) {
            return isOpen
                ? require('../../../../../assets/images/eye.png')
                : require('../../../../../assets/images/no-eye.png');
        },
        changeEyeInfo(type, sourceBillNo, index) {
            this.$emit('changeEyeInfo', type, sourceBillNo, index);
        },
        // 收件地址，看有没有返回receiverDetailAddr。没有且IOX，DOX拿后台数据。
        needAddressEye(data) {
            if (data.receiverDetailAddr) {
                return true;
            }
            if (
                data.sourceBillNo.startsWith('DOX') ||
                data.sourceBillNo.startsWith('IOX')
            ) {
                return true;
            }
            return false;
        },
        needPhoneEye(data) {
            if (
                data.sourceBillNo.startsWith('DOX') ||
                data.sourceBillNo.startsWith('IOX')
            ) {
                return true;
            }
            return false;
        }
    }
};
</script>

<style lang="less" scoped>
.process-time-line {
    height: calc(100vh - 290px);
    overflow: auto;
    .no-warp {
        white-space: nowrap;
    }
    .process-card {
        margin-bottom: 16px;
    }
    .process-card-top {
        display: flex;
        align-items: center;
        .el-icon-arrow-down {
            margin-right: 12px;
            border-radius: 50%;
            background: #c4cdd5;
            color: #fff;
        }
        .text {
            margin-right: 5px;
            font-size: 14px;
        }
        .date {
            color: #4285f5;
        }
        .content-icon {
            width: 18px;
        }
    }
    .processTimeLine-info {
        margin-top: 10px;
    }
    .processTimeLine-info-name {
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        font-weight: 600;
    }
    .processTimeLine-info-label {
        margin: 0px 8px;
        padding: 2px;
        font-size: 12px;
        color: #4285f5;
        background: #ecf3fe;
    }
    .processTimeLine-info-type {
        padding: 2px;
        font-size: 12px;
        color: #ff8800;
        background: #ffe8cc;
    }
    .processTimeLine-info {
        padding: 16px;
        margin: 0px 24px;
        background: #fafafa;
        box-sizing: border-box;
        .processTimeLine-info-content {
            display: flex;
            margin-top: 8px;
            .processTimeLine-info-left,
            .processTimeLine-info-right {
                flex: 1;
                .processTimeLine-info-left-title {
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    font-weight: 600;
                }
            }
        }
        .processTimeLine-row {
            margin-top: 8px;
            .processTimeLine-row-label {
                font-size: 12px;
                color: #888888;
                text-align: left;
                line-height: 20px;
                font-weight: 400;
                margin-right: 2px;
                display: inline-block;
            }
            .processTimeLine-row-labelIcon {
                flex-shrink: 0;
                color: #4285f5;
            }
            .processTimeLine-row-val {
                font-size: 12px;
                color: #333333;
                line-height: 20px;
                font-weight: 400;
            }
            .color4285F5 {
                color: #4285f5;
            }
        }
        .processTimeLine-rowTwo {
            display: flex;
            .processTimeLine-rowTwo-item {
                flex: 0.4;
            }
            .depart{
                flex: 0.7;
                white-space: nowrap;
            }
        }
        .processTimeLine-info-right {
            flex: 1;
        }
        .processTimeLine-logistics {
            border-top: 1px solid #e5e5e5;
            margin-top: 8px;
            .el-collapse {
                border: 0px;
            }
            .logistics-content-heightLight {
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }
            .logistics-content-info {
                display: flex;
                .logistics-info-left {
                    flex: 1;
                }
                .logistics-info-right {
                    flex: 1;
                }
            }
        }
    }
    .process-card-context {
        margin-top: 8px;
        padding: 15px;
        margin-left: 24px;
        background: #f9f9f9;
        border-radius: 4px;
    }
    .flex-row {
        display: flex;
        align-items: center;
        .text {
            margin-left: 50px;
        }
    }
    .card-row {
        margin-bottom: 8px;
        .label {
            flex-shrink: 0;
            color: #888888;
        }
        .value {
            margin-right: 10px;
        }
    }
    .card-context-title {
        font-size: 12px;
        color: #333333;
        font-weight: 600;
    }
    .card-msg-type {
        padding: 4px;
        margin-bottom: 5px;
        margin-left: 10px;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 500;
        color: #4285f5;
        background: #ecf3fe;
    }
    .card-row-item {
        width: 400px;
    }
    .card-flow {
        position: relative;
        display: inline-block;
        .icon-to {
            top: 50%;
            right: 50%;
            transform: translate(50%, -50%);
            position: absolute;
            width: 30px;
        }
    }
    .card-flow-detail {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 400px;
        // height: 86px;
        margin-right: 3px;
        padding: 12px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 4px;
        background: #ffffff;
        white-space: nowrap;
    }
    .card-flow-in {
        padding-left: 20px;
        margin-right: 0px;
        margin-left: 3px;
        // text-align: right;
    }
    .card-logistics-top {
        margin-bottom: 8px;
    }
    .card-logistics {
        box-sizing: border-box;
        margin-top: 10px;
        padding: 12px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 4px;
        width: 806px;
        background: #ffffff;
    }
    .processTimeLine-eye {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }
    .processTimeLine-icon {
        width: 10px;
    }
    /deep/ .el-collapse-item__header {
        background-color: #fafafa;
        height: 40px;
        line-height: 40px;
        .el-collapse-item__arrow {
            display: none;
        }
    }
    /deep/ .el-collapse-item__wrap {
        background-color: #fafafa;
    }
}
</style>
